export default class Sliderx {
    private $el: JQuery;
    private $body: JQuery;
    private $list: JQuery;
    private $items: JQuery;

    private $prev: JQuery;
    private $next: JQuery;

    private cur: number;

    public constructor($el: JQuery) {
        this.$el = $el;

        this.initHtml();
    }

    public initHtml(): void {
        this.$body = $('.sliderx__body', this.$el);
        this.$list = $('.sliderx__list', this.$el);
        this.$items = $('.sliderx__item', this.$el);
        this.$prev = $('.sliderx__prev', this.$el);
        this.$next = $('.sliderx__next', this.$el);


        this.$prev.on('click', () => {
            this.prev();
        });

        this.$next.on('click', () => {
            this.next();
        });

        this.$el.addClass('sliderx--inited');

        $(window).on('resize', () => {
            this.updateLayout(true);
        });

        this.cur = 0;

        this.$el.addClass('sliderx--p' + this.cur);

        this.updateLayout();
    }

    public updateLayout(force?: boolean): void {
        const w = this.$body.width();

        this.$items.each((ix, item) => {
            const $item = $(item);

            $item.css({
                'width': w,
                'left':  ix * w
            });
        });

        if (force) {
            this.$el.addClass('sliderx--force');
        }

        this.$list.css({
            'left': -this.cur * w
        });

        this.$prev.toggleClass('sliderx__prev--disabled', this.cur == 0);
        this.$prev.prop('disabled', this.cur == 0);

        this.$next.toggleClass('sliderx__next--disabled', this.cur == this.$items.length - 1);
        this.$next.prop('disabled', this.cur == this.$items.length - 1);

        if (force) {
            this.$list[0].offsetHeight;
            this.$el.removeClass('sliderx--force');
        }
    }

    public getIndex(): number {
        return this.cur;
    }

    public getSize(): number {
        return this.$items.length;
    }

    public goto(ix: number): void {
        // const $prev = this.cur != null ? this.$el.eq(this.cur) : null;
        // const $next = this.$el.eq(ix);

        this.$el.removeClass('sliderx--p' + this.cur);

        if (ix >= 0) {
            this.$el.addClass('sliderx--p' + ix);
        }

        this.cur = ix;

        this.updateLayout();
    }

    public next(): void {
        let ix = this.getIndex();
        const size = this.getSize();

        ix ++;

        if (ix >= size) {
            ix = size - 1;
        }

        this.goto(ix);
    }

    public prev(): void {
        let ix = this.getIndex();
        const size = this.getSize();

        ix --;

        if (ix < 0) {
            ix = 0;
        }

        this.goto(ix);
    }
}
